<article class="lum-c-inv-list lum-page lum-page__card lum-c-inv-list">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">SKUs</h2>
    <div class="lum-page-header__actions">
      <div ngbDropdown class="d-inline-block" container="body">
        <div class="header-actions">
          <button
            class="lum-button lum-button--primary"
            *ngIf="authService.loginUser.prwx == 7"
            (click)="createRfqForClient()"
          >
            <i class="fas fa-plus"></i> Create
          </button>
          <button
            [matMenuTriggerFor]="exportDropdown"
            class="lum-button lum-button--secondary"
          >
            Export <caret></caret>
          </button>
          <mat-menu #exportDropdown="matMenu" xPosition="before">
            <button mat-menu-item (click)="exportList(exportType.PDF)">
              {{ exportType.PDF }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.FULL_MASTER_SKU_EXCEL)"
            >
              {{ exportType.FULL_MASTER_SKU_EXCEL }}
            </button>
            <button mat-menu-item (click)="exportList(exportType.MASTER_SKU_EXCEL)">
              {{ exportType.MASTER_SKU_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.MASTER_SKU_DETAILS_EXCEL)"
            >
              {{ exportType.MASTER_SKU_DETAILS_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.VARIANT_SKU_EXCEL)"
            >
              {{ exportType.VARIANT_SKU_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.VARIANT_SKU_DETAILS_EXCEL)"
            >
              {{ exportType.VARIANT_SKU_DETAILS_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportAlternateSku(eExportsConstant.XLSX)"
            >
              {{ exportType.ALTERNATE_SKU_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportAlternateSku(eExportsConstant.CSV)"
            >
              {{ exportType.ALTERNATE_SKU_CSV }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.SKU_WITH_CUSTOM_FIELDS_EXCEL)"
            >
              {{ exportType.SKU_WITH_CUSTOM_FIELDS_EXCEL }}
            </button>
            <button
              mat-menu-item
              (click)="exportList(exportType.SKU_WITH_CUSTOM_FIELDS_CSV)"
            >
              {{ exportType.SKU_WITH_CUSTOM_FIELDS_CSV }}
            </button>
            <button mat-menu-item (click)="exportTemplate()">
              Export Customized Format
            </button>
          </mat-menu>

          <button
            [matMenuTriggerFor]="skuDropdown"
            class="lum-button lum-button--square lum-button--secondary"
            type="button"
          >
            <i class="flaticon-more-1"></i>
            <span class="sr-only">More Actions</span>
          </button>
          <mat-menu #skuDropdown="matMenu" xPosition="before">
            <button
              *ngIf="ftSupplierSourceSku"
              mat-menu-item
              [routerLink]="['/inventory/supplier-sku']"
            >
              Supplier SKU
            </button>
            <button
              mat-menu-item
              [routerLink]="['/inventory/archived-rfqs']"
              *ngIf="authService.loginUser.prwx == 7"
            >
              SKU Archives
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </header>

  <div class="lum-page-content" id="scroll-top-pagination">
    <div *ngIf="rfqRecord">
      <dynamic-filters
        [configuration]="filterConfiguration"
        localStorageId="quotes/inventory/list"
        [defaultIds]="['sku', 'product', 'disable_grouping']"
        (queryChange)="onQueryChange($event)"
      ></dynamic-filters>

      <div class="table-actions">
        <button
          [matMenuTriggerFor]="tableSelectionMenu"
          *ngIf="checkedCount > 0"
          class="btn btn-primary mr-2"
        >
          {{ this.checkedCount }} Selected SKUs <caret></caret>
        </button>
        <mat-menu #tableSelectionMenu="matMenu">
          <button mat-menu-item (click)="addUnderNewMasterSku()">
            Add under new master SKU
          </button>
          <button
            mat-menu-item
            (click)="updateSelected()"
            [disabled]="rfqService.gettingRecords || isLoadingRecords"
            [ngClass]="{
              'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                rfqService.gettingRecords || isLoadingRecords,
            }"
          >
            Bulk update
          </button>
          <button mat-menu-item (click)="assignSelected()">
            Assign to staff
          </button>
          <button mat-menu-item (click)="promoteVariantToMasterSku()">
            Promote Variant SKU to Master SKU
          </button>
          <button
            mat-menu-item
            (click)="deleteSelected()"
            *ngxPermissionsOnly="['skus.delete']"
          >
            Delete
          </button>
        </mat-menu>

        <dynamic-columns
          [configuration]="columns"
          localStorageId="quotes/inventory/list"
        ></dynamic-columns>
      </div>

      <div class="table-content">
        <ng-template #sort let-order="order" let-sort="sort" let-field="field">
          <div class="pull-right sort">
            <i class="fas fa-sort" *ngIf="order !== field"></i>
            <i class="fas fa-sort-up" *ngIf="order === field && sort === 'asc'"></i>
            <i
              class="fas fa-sort-down"
              *ngIf="order === field && sort === 'desc'"
            ></i>
          </div>
        </ng-template>

        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>
                <mat-checkbox
                  color="primary"
                  [(ngModel)]="checkedAll"
                  (ngModelChange)="checkAll()"
                ></mat-checkbox>
              </th>
              <th
                *ngIf="columnActive('createdDate')"
                class="link"
                (click)="setOrder('created_at')"
                [translate]="'TITLES.DATE_TIME_CREATED'"
              >
                {{ columnLabel('createdDate') }}
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: 'created_at',
                    }
                  "
                >
                </ng-container>
              </th>
              <th
                *ngIf="columnActive('sku')"
                class="link"
                (click)="setOrder('internal_sku')"
                [translate]="'TITLES.SKU'"
              >
                {{ columnLabel('sku') }}
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: 'internal_sku',
                    }
                  "
                ></ng-container>
              </th>
              <th
                *ngIf="columnActive('productName')"
                class="link"
                (click)="setOrder('product_name')"
                [translate]="'TITLES.PRODUCT'"
              >
                {{ columnLabel('productName') }}
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: 'product_name',
                    }
                  "
                >
                </ng-container>
              </th>
              <th *ngIf="columnActive('productImage')">Product Image</th>
              <th *ngIf="columnActive('kitItems')">Kit Items</th>
              <th *ngIf="columnActive('upc')">UPC</th>
              <th *ngIf="columnActive('location')">Location</th>
              <th
                *ngIf="columnActive('incoming')"
                class="link"
                (click)="setOrder(dynamicQtyStockString('qty_incoming_total'))"
              >
                Incoming
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: dynamicQtyStockString('qty_incoming_total'),
                    }
                  "
                >
                </ng-container>
              </th>
              <th
                *ngIf="columnActive('onHand')"
                class="link"
                (click)="setOrder(dynamicQtyStockString('qty_onhand_total'))"
              >
                On Hand
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: dynamicQtyStockString('qty_onhand_total'),
                    }
                  "
                >
                </ng-container>
              </th>
              <th
                *ngIf="columnActive('pending')"
                class="link"
                (click)="setOrder(dynamicQtyStockString('qty_pending_total'))"
              >
                Pending
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: dynamicQtyStockString('qty_pending_total'),
                    }
                  "
                >
                </ng-container>
              </th>
              <th
                *ngIf="columnActive('available')"
                class="link"
                (click)="setOrder(dynamicQtyStockString('qty_available_total'))"
              >
                Available
                <ng-container
                  *ngTemplateOutlet="
                    sort;
                    context: {
                      sort: params.sort,
                      order: params.order,
                      field: dynamicQtyStockString('qty_available_total'),
                    }
                  "
                >
                </ng-container>
              </th>
              <!-- <th>
						Products
						<ng-container *ngTemplateOutlet="sort;context:{order: params.order, field: 'qty_products'}">
						</ng-container>
					</th> -->
              <th
                *ngIf="
                  authService.loginUser.role >= 2 &&
                  columnActive('sourcingAssignees')
                "
              >
                Sourcing Assignees
              </th>
              <!-- <th *ngIf="authService.loginUser.role > 2">
						Sales Team Assignees
					</th> -->
              <th *ngIf="columnActive('wholesalePrice')" class="text-right">
                W Price
              </th>
              <ng-container *ngxPermissionsOnly="'skuUnitCost.read'">
                <th class="text-right" *ngIf="columnActive('unitCost')">
                  Unit Cost
                </th>
              </ng-container>

              <th *ngIf="columnActive('category')">Category</th>
              <th *ngIf="columnActive('subCategory')">Sub Category</th>
              <th *ngIf="columnActive('tags')">Tags</th>
              <th *ngIf="columnActive('customFields')">Custom Fields</th>
              <th *ngIf="columnActive('uom')" class="link">UOM</th>
              <th class="text-center">&nbsp;</th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngIf="
                (!rfqService.gettingRecords || !isLoadingRecords) &&
                rfqRecord.data &&
                rfqRecord.data.length == 0
              "
            >
              <td colspan="10" class="text-center">
                <br />
                <h6 class="text-warning">No record found.</h6>
                <br />
              </td>
            </tr>

            <ng-container *ngFor="let r of rfqRecord.data; let i = index">
              <tr
                class="lum-c-inv-list__table-item"
                [ngClass]="{
                  'checked': checked[r.id],
                  'low-quantity':
                    r.qty_limit_notify > 0 && r.qty_available <= r.qty_limit_notify,
                }"
              >
                <td>
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="checked[r.id]"
                    (ngModelChange)="toggleCheckbox(r)"
                  ></mat-checkbox>
                  <div>
                    <button
                      *ngIf="
                        r.variant_skus_count > 0 && !filterQuery.disable_grouping
                      "
                      type="button"
                      class="linkish lum-c-inv-list__table-item__expand"
                      (click)="toggleVariantSku(r)"
                    >
                      <i
                        [ngClass]="{
                          'fas': true,
                          'fa-caret-square-right': !r.expanded,
                          'fa-caret-square-down': r.expanded,
                        }"
                      ></i>
                      <span class="sr-only">
                        {{ r.expanded ? 'Hide' : 'Show' }} Variants of this SKU
                      </span>
                    </button>
                  </div>
                </td>
                <td *ngIf="columnActive('createdDate')">
                  {{ r.created_at | date: 'medium' }}
                </td>
                <td *ngIf="columnActive('sku')">
                  <a
                    *ngIf="r.internal_sku; else noSku"
                    [href]="'/inventory/' + r.id + '/view'"
                    title="View Details"
                    [ngClass]="{ 'text-linethrough': r.is_discontinued == 1 }"
                    (click)="showDetails($event, r)"
                    >{{ r.internal_sku }}</a
                  >
                  <ng-template #noSku>N/A</ng-template>
                  <div>
                    <span
                      class="kt-badge kt-badge-sm kt-badge--pill kt-badge--default"
                    >
                      <ng-container *ngIf="r.type === null"> PRODUCT </ng-container>
                      <ng-container *ngIf="r.type !== null">
                        {{ r.type }}
                      </ng-container>
                    </span>
                  </div>
                </td>
                <td *ngIf="columnActive('productName')">
                  <button
                    type="button"
                    class="star mr-1 linkish"
                    (click)="toggleRfqStarredState(r)"
                    ngbPopover="{{ r.starred ? r.starred_notes : '' }}"
                    placement="top"
                    triggers="mouseenter:mouseleave"
                    title="{{ r.starred ? '' : 'Mark this SKU as starred' }}"
                  >
                    <i class="fas fa-star text-success" *ngIf="r.starred == 1"></i>
                    <i
                      class="far fa-star text-secondary"
                      *ngIf="r.starred == 0"
                    ></i>
                  </button>

                  <a
                    *ngIf="r.master_sku_id != 0"
                    [href]="'/inventory/' + r.id + '/view'"
                    title="View Details"
                    matTooltip="Parent SKU: {{ r.master_sku_id }}"
                    [ngClass]="{
                      'text-linethrough': r.is_discontinued == 1,
                    }"
                    class="link mr-1"
                    (click)="showDetails($event, r)"
                  >
                    <span class="sku" *ngIf="r.internal_sku">
                      [{{ r.internal_sku }}]
                    </span>
                    {{ r.product_name }}
                  </a>
                  <a
                    *ngIf="r.master_sku_id == 0"
                    [href]="'/inventory/' + r.id + '/view'"
                    title="View Details"
                    [ngClass]="{
                      'text-linethrough': r.is_discontinued == 1,
                    }"
                    class="link mr-1"
                    (click)="showDetails($event, r)"
                  >
                    {{ r.product_name }}
                  </a>

                  <div *ngIf="r.sellable">
                    <span
                      class="kt-badge kt-badge-sm kt-badge--pill kt-badge--default"
                    >
                      <i class="fas fa-check"></i>
                      Sellable
                    </span>
                  </div>
                </td>
                <td *ngIf="columnActive('productImage')">
                  <div class="form-group mb-3">
                    <a
                      *ngIf="r.hasValidProductImage; else invalidPhoto"
                      class="value"
                      [href]="r.photo"
                      target="_blank"
                    >
                      <img [src]="r.photo" height="60" [alt]="r.product_name" />
                    </a>
                    <ng-template #invalidPhoto>
                      <p class="d-inline-block mb-0 text-cloud-600">
                        <small><em> -- none -- </em></small>
                      </p>
                    </ng-template>
                  </div>
                </td>
                <td *ngIf="columnActive('kitItems')">
                  <dl
                    *ngIf="r.type === productTypes.KIT"
                    class="
                      lum-c-inv-list__kit-list dl-grid dl-grid--inline dl-nowrap
                    "
                  >
                    <ng-container *ngFor="let kitItem of r.kit_items">
                      <dt class="lum-c-inv-list__kit-list__item-identity">
                        [{{ kitItem?.product?.internal_sku }}]
                        {{ kitItem?.product?.product_name }}
                      </dt>
                      <dd class="lum-c-inv-list__kit-list__item-details">
                        &times;{{
                          (kitItem?.quantity | decimalPlaces) +
                            kitItem?.unit_of_measure?.name
                        }}
                      </dd>
                    </ng-container>
                  </dl>
                </td>
                <td *ngIf="columnActive('upc')">
                  {{ r.upc ? r.upc : '' }}
                </td>
                <td *ngIf="columnActive('location')">
                  <div *ngIf="r.location_stocks && r.location_stocks.length > 0">
                    <cnc-rfq-stock-locations
                      [locationStocks]="
                        r.location_stocks | transformKeys: 'snakeToCamel'
                      "
                      [rfq]="r"
                      [collapse]="true"
                    ></cnc-rfq-stock-locations>
                  </div>
                </td>

                <ng-container *ngIf="r.variant_skus_count > 0">
                  <ng-template #invListVariantsMain let-quantity="quantity">
                    <dt class="text-right">
                      <i class="fas fa-box" title="Master SKU Quantity"></i>&nbsp;:
                    </dt>
                    <dd class="text-right">
                      <strong>{{ quantity ?? 0 | decimalPlaces }}</strong>
                    </dd>
                  </ng-template>
                  <ng-template #invListVariantsConsolidated let-quantity="quantity">
                    <dt class="text-right">
                      <i class="fas fa-boxes" title="Consolidated Variant SKU"></i
                      >&nbsp;:
                    </dt>
                    <dd class="text-right">
                      {{ quantity ?? 0 | decimalPlaces }}
                    </dd>
                  </ng-template>

                  <td *ngIf="columnActive('incoming')">
                    <dl class="dl-grid dl-grid--inline column-gap-3">
                      <a
                        *ngIf="
                          r.stock?.qty_incoming && r.stock.qty_incoming > 0;
                          else invListVariantsMain
                        "
                        routerLink="/orders"
                        [queryParams]="{ sku: r.internal_sku }"
                        title="View SKU purchase orders"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            invListVariantsMain;
                            context: { quantity: r.stock.qty_incoming }
                          "
                        ></ng-container>
                      </a>
                      <ng-container
                        *ngTemplateOutlet="
                          invListVariantsConsolidated;
                          context: { quantity: r?.totalVariantQtyIncoming ?? 0 }
                        "
                      ></ng-container>
                    </dl>
                  </td>

                  <td *ngIf="columnActive('onHand')">
                    <dl class="dl-grid dl-grid--inline column-gap-3">
                      <ng-container
                        *ngTemplateOutlet="
                          invListVariantsMain;
                          context: { quantity: r.stock?.qty_onhand ?? 0 }
                        "
                      ></ng-container>
                      <ng-container
                        *ngTemplateOutlet="
                          invListVariantsConsolidated;
                          context: { quantity: r?.totalVariantQtyOnHand ?? 0 }
                        "
                      ></ng-container>
                    </dl>
                  </td>

                  <td *ngIf="columnActive('pending')">
                    <dl class="dl-grid dl-grid--inline column-gap-3">
                      <button
                        *ngIf="
                          r.type !== productTypes.KIT && r.pendingQuantity > 0;
                          else invListVariantsMain
                        "
                        class="linkish"
                        title="View pending stock transactions"
                        (click)="viewPendingRfqStockDetails(r)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            invListVariantsMain;
                            context: { quantity: r.pendingQuantity }
                          "
                        ></ng-container>
                      </button>
                      <ng-container
                        *ngTemplateOutlet="
                          invListVariantsConsolidated;
                          context: { quantity: r?.totalVariantQtyPending ?? 0 }
                        "
                      ></ng-container>
                    </dl>
                  </td>

                  <td *ngIf="columnActive('available')">
                    <dl class="dl-grid dl-grid--inline column-gap-3">
                      <div
                        *ngIf="r.stock; else invListVariantsMain"
                        [ngClass]="{
                          'text-danger font-500':
                            r.qty_limit_notify > 0 &&
                            r.qty_limit_notify >=
                              r.stock.qty_onhand - r.stock.qty_pending,
                        }"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            invListVariantsMain;
                            context: {
                              quantity: r.stock.qty_onhand - r.stock.qty_pending,
                            }
                          "
                        ></ng-container>
                      </div>
                      <ng-container
                        *ngTemplateOutlet="
                          invListVariantsConsolidated;
                          context: {
                            quantity: r?.totalVariantQtyAvailable ?? 0,
                          }
                        "
                      ></ng-container>
                    </dl>
                  </td>
                </ng-container>
                <ng-container *ngIf="!r.variant_skus_count">
                  <td *ngIf="columnActive('incoming')">
                    <span
                      *ngIf="
                        r.type === productTypes.KIT ||
                        !r.stock ||
                        !r.stock.qty_incoming ||
                        r.stock.qty_incoming <= 0
                      "
                    >
                      {{
                        (r.stock?.qty_incoming && r.stock.qty_incoming > 0
                          ? r.stock.qty_incoming
                          : 0
                        ) | decimalPlaces
                      }}
                    </span>
                    <button
                      *ngIf="
                        r.type !== productTypes.KIT &&
                        r.stock?.qty_incoming &&
                        r.stock.qty_incoming > 0
                      "
                      class="linkish"
                      title="View pending stock transactions"
                      (click)="viewIncomingRfqStockDetails(r)"
                    >
                      {{
                        (r.stock.qty_incoming && r.stock.qty_incoming > 0
                          ? r.stock.qty_incoming
                          : 0
                        ) | decimalPlaces
                      }}
                    </button>
                  </td>
                  <td *ngIf="columnActive('onHand')">
                    {{ (r.stock ? r.stock.qty_onhand : 0) | decimalPlaces }}
                  </td>
                  <td *ngIf="columnActive('pending')">
                    <a
                      *ngIf="
                        r.type !== productTypes.KIT && r.pendingQuantity > 0;
                        else noPending
                      "
                      href="javascript:;"
                      (click)="viewPendingRfqStockDetails(r)"
                      title="View pending stock transactions"
                    >
                      {{ r.pendingQuantity | decimalPlaces }}
                    </a>
                    <ng-template #noPending>
                      {{ r.pendingQuantity | decimalPlaces }}
                    </ng-template>
                  </td>
                  <td *ngIf="columnActive('available')">
                    <span *ngIf="!r.stock">0 </span>
                    <span
                      *ngIf="r.stock"
                      [ngClass]="{
                        'text-danger font-500':
                          r.qty_limit_notify > 0 &&
                          r.stock.qty_onhand - r.stock.qty_pending <=
                            r.qty_limit_notify,
                      }"
                    >
                      {{ r.stock.qty_onhand - r.stock.qty_pending | decimalPlaces }}
                    </span>
                  </td>
                </ng-container>

                <td
                  *ngIf="
                    authService.loginUser.role >= 2 &&
                    columnActive('sourcingAssignees')
                  "
                >
                  <div class="sourcing">
                    <ul *ngIf="r.admins && r.admins.length > 0">
                      <li *ngFor="let admin of r.admins">
                        <span *ngIf="admin.users && admin.users.firstname">
                          {{ admin.users.firstname }}
                          {{ admin.users.lastname }}
                        </span>
                      </li>
                    </ul>
                    <ul *ngIf="r.members && r.members.length > 0">
                      <li *ngFor="let member of r.members">
                        <span *ngIf="member.users && member.users.firstname">
                          {{ member.users.firstname }}
                          {{ member.users.lastname }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </td>
                <td class="text-right" *ngIf="columnActive('wholesalePrice')">
                  {{ r.wholesale_price | currency: '' }}
                </td>
                <ng-container *ngxPermissionsOnly="'skuUnitCost.read'">
                  <td class="text-right" *ngIf="columnActive('unitCost')">
                    <span
                      class="weighted"
                      popoverTitle="Unit Costs"
                      placement="top"
                      triggers="mouseenter:mouseleave"
                    >
                      <span class="value">
                        {{
                          (r.base_price ? r.base_price.weighted : 0) | currency: ''
                        }}</span
                      >
                    </span>
                  </td>
                </ng-container>
                <td *ngIf="columnActive('category')">
                  {{ r.category?.product_category }}
                </td>
                <td *ngIf="columnActive('subCategory')">
                  {{ r.subcategory?.sub_category }}
                </td>
                <td *ngIf="columnActive('tags')">
                  <span
                    *ngFor="let tag of r.tags"
                    class="
                      kt-badge kt-badge--secondary kt-badge-sm kt-badge--outline kt-badge--pill
                    "
                    >{{ tag.tag_details?.name }}</span
                  >
                </td>
                <td *ngIf="columnActive('customFields')">
                  <lum-custom-field-value-details
                    [customFieldValues]="r?.custom_field_values || []"
                  ></lum-custom-field-value-details>
                </td>
                <td *ngIf="columnActive('uom')">
                  <span *ngIf="r?.type !== eItemType.KIT">
                    {{ r?.unit_class?.name }}
                  </span>
                </td>
                <td
                  class="lum-c-inv-list--table__actions flex justify-end"
                  [ngClass]="{
                    'lum-c-inv-list--table__actions-striped': i % 2 === 0,
                  }"
                >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menuActions"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </tr>

              <mat-menu #menuActions="matMenu">
                <button
                  *ngIf="authService.loginUser.prwx == 7"
                  mat-menu-item
                  (click)="editRfq(r)"
                >
                  <i class="fas fa-edit"></i> Edit SKU
                </button>
                <button
                  *ngIf="checkIfCanCreateAdjustmentEntry(r)"
                  mat-menu-item
                  (click)="createAdjustmentEntry(r)"
                >
                  <i class="fas fa-edit"></i> Create Adjustment Entry
                </button>
                <button
                  *ngIf="
                    authService.loginUser.role >= 88 &&
                    authService.loginUser.prwx == 7
                  "
                  mat-menu-item
                  (click)="assignRFQ(r)"
                >
                  <i class="fas fa-user-friends"></i>
                  Assign SKU Admin
                </button>
                <button
                  *ngIf="
                    authService.loginUser.role == 8 &&
                    authService.loginUser.prwx == 7
                  "
                  mat-menu-item
                  (click)="assignRFQ(r)"
                >
                  <i class="fas fa-user-friends"></i>
                  Assign SKU Member
                </button>
                <button
                  *ngIf="authService.loginUser.prwx == 7"
                  mat-menu-item
                  (click)="addClient(r)"
                >
                  <i class="fas fa-user-friends"></i>
                  Assign SKU Client
                </button>
                <button
                  *ngIf="
                    authService.loginUser.role != 2 &&
                    authService.loginUser.prwx == 7
                  "
                  mat-menu-item
                  (click)="addQuotation(r)"
                >
                  <i class="fas fa-plus"></i> Add Quotation
                </button>
                <button mat-menu-item (click)="exportRfqToPDF(r)">
                  <i class="fas fa-file-alt"></i>
                  View Quotations
                </button>
                <button mat-menu-item (click)="exportRfqToPDF(r)">
                  <i class="fas fa-file-pdf text-info"></i>
                  Export to PDF
                </button>
                <button
                  *ngIf="r.variant_parent_id !== 0"
                  mat-menu-item
                  (click)="promoteVariantToMasterSku(r)"
                >
                  <i class="fas fa-level-up-alt"></i> Promote Variant SKU to Master
                  SKU
                </button>
                <button
                  *ngIf="
                    r.is_discontinued == 0 &&
                    authService.loginUser.is_admin &&
                    authService.loginUser.prwx == 7
                  "
                  mat-menu-item
                  (click)="discontinue(r)"
                  class="text-warning"
                >
                  <i class="fas fa-stop text-warning"></i>
                  Discontinue SKU
                </button>
                <button
                  *ngIf="
                    r.is_discontinued == 1 &&
                    authService.loginUser.is_admin &&
                    authService.loginUser.prwx == 7
                  "
                  mat-menu-item
                  (click)="continue(r)"
                  class="text-info"
                >
                  <i class="fas fa-play text-info"></i>
                  Reactivate SKU
                </button>
                <button
                  *ngxPermissionsOnly="['skus.delete']"
                  mat-menu-item
                  (click)="delete(r)"
                  class="text-danger"
                >
                  <i class="fas fa-trash text-danger"></i>
                  Delete SKU
                </button>
              </mat-menu>

              <ng-container *ngIf="r.expanded && r.variant_skus_count > 0">
                <tr *ngIf="r.gettingVariantSKUs">
                  <td colspan="12" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Getting variant SKUs...
                  </td>
                </tr>
                <tr
                  *ngFor="let vs of r.variant_skus; let vsi = index"
                  class="
                    lum-c-inv-list__table-item lum-c-inv-list__table-item--variant
                  "
                  [ngClass]="{
                    'low-quantity':
                      vs.qty_limit_notify > 0 &&
                      vs.qty_available <= vs.qty_limit_notify,
                    'searched-row': vs.skuMatched && !vs.skuExactWordMatch,
                    'searched-row-exact': vs.skuMatched && vs.skuExactWordMatch,
                  }"
                >
                  <td>
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="checked[vs.id]"
                      (ngModelChange)="countChecked()"
                    ></mat-checkbox>
                  </td>
                  <td *ngIf="columnActive('createdDate')">
                    {{ vs.created_at | date: 'medium' }}
                  </td>
                  <td *ngIf="columnActive('sku')" class="text-nowrap">
                    <a
                      *ngIf="vs.internal_sku; else noSku"
                      [href]="'/inventory/' + vs.id + '/view'"
                      title="View Details"
                      [ngClass]="{
                        'text-linethrough': vs.is_discontinued == 1,
                      }"
                      (click)="showDetails($event, vs)"
                      >{{ vs.internal_sku }}</a
                    >
                    <ng-template #noSku>N/A</ng-template>
                  </td>
                  <td class="text-capitalize" *ngIf="columnActive('productName')">
                    <a
                      [href]="'/inventory/' + vs.id + '/view'"
                      class="star mr-1"
                      (click)="toggleRfqStarredState(vs)"
                      ngbPopover="{{ vs.starred ? vs.starred_notes : '' }}"
                      placement="top"
                      triggers="mouseenter:mouseleave"
                      title="{{ vs.starred ? '' : 'Mark this SKU as starred' }}"
                    >
                      <i
                        class="fas fa-star text-success"
                        *ngIf="vs.starred === 1"
                      ></i>
                      <i
                        class="far fa-star text-secondary"
                        *ngIf="vs.starred === 0"
                      ></i>
                    </a>

                    <a
                      [href]="'/inventory/' + vs.id + '/view'"
                      title="View Details"
                      [ngClass]="{
                        'text-linethrough': vs.is_discontinued == 1,
                      }"
                      class="link mr-1"
                      (click)="showDetails($event, vs)"
                    >
                      {{ vs.product_name }}
                    </a>
                  </td>

                  <td *ngIf="columnActive('productImage')">
                    <div class="form-group mb-3">
                      <a
                        *ngIf="vs.hasValidProductImage; else invalidPhoto"
                        class="value"
                        [href]="vs.photo"
                        target="_blank"
                      >
                        <img [src]="vs.photo" height="60" [alt]="vs.product_name" />
                      </a>
                      <ng-template #invalidPhoto>
                        <p class="d-inline-block mb-0 text-cloud-600">
                          <small><em> -- none -- </em></small>
                        </p>
                      </ng-template>
                    </div>
                  </td>

                  <td *ngIf="columnActive('kitItems')">
                    <dl
                      *ngIf="r.type === productTypes.KIT"
                      class="
                        lum-c-inv-list__kit-list dl-grid dl-grid--inline dl-nowrap
                      "
                    >
                      <ng-container
                        *ngFor="let kitItem of vs.kit_items; trackBy: trackById"
                      >
                        <dt class="lum-c-inv-list__kit-list__item-identity">
                          [{{ kitItem?.product?.internal_sku }}]
                          {{ kitItem?.product?.product_name }}
                        </dt>
                        <dd class="lum-c-inv-list__kit-list__item-details">
                          &times;{{
                            (kitItem?.quantity | decimalPlaces) +
                              kitItem?.unit_of_measure?.name
                          }}
                        </dd>
                      </ng-container>
                    </dl>
                  </td>
                  <td *ngIf="columnActive('upc')">
                    {{ vs.upc ? vs.upc : '' }}
                  </td>
                  <td *ngIf="columnActive('location')">
                    <div
                      *ngIf="vs.location_stocks && vs.location_stocks.length > 0"
                    >
                      <cnc-rfq-stock-locations
                        [locationStocks]="
                          vs.location_stocks | transformKeys: 'snakeToCamel'
                        "
                        [rfq]="vs"
                        [collapse]="true"
                      ></cnc-rfq-stock-locations>
                    </div>
                  </td>
                  <td *ngIf="columnActive('incoming')">
                    <a
                      *ngIf="
                        vs.stock &&
                        vs.stock.qty_incoming &&
                        vs.stock.qty_incoming > 0
                      "
                      href="javascript:;"
                      (click)="viewIncomingRfqStockDetails(vs)"
                      title="View pending stock transactions"
                    >
                      {{
                        (vs.stock.qty_incoming && vs.stock.qty_incoming > 0
                          ? vs.stock.qty_incoming
                          : 0
                        ) | decimalPlaces
                      }}
                    </a>
                    <span
                      *ngIf="
                        !vs.stock ||
                        !vs.stock.qty_incoming ||
                        vs.stock.qty_incoming <= 0
                      "
                    >
                      0
                    </span>
                  </td>
                  <td *ngIf="columnActive('onHand')">
                    {{
                      (vs.stock && vs.stock.qty_onhand > 0
                        ? vs.stock.qty_onhand
                        : 0
                      ) | decimalPlaces
                    }}
                  </td>
                  <td *ngIf="columnActive('pending')">
                    <a
                      *ngIf="vs.stock && vs.stock.qty_pending; else noPending"
                      href="javascript:;"
                      (click)="viewPendingRfqStockDetails(vs)"
                      title="View pending stock transactions"
                    >
                      {{ vs.stock.qty_pending | decimalPlaces }}
                    </a>
                    <ng-template #noPending> 0 </ng-template>
                  </td>
                  <td *ngIf="columnActive('available')">
                    <span *ngIf="!vs.stock"> 0 </span>
                    <span
                      *ngIf="vs.stock"
                      [ngClass]="{
                        'text-danger font-500':
                          vs.qty_limit_notify > 0 &&
                          vs.stock.qty_onhand - vs.stock.qty_pending <=
                            vs.qty_limit_notify,
                      }"
                    >
                      {{
                        vs.stock.qty_onhand - vs.stock.qty_pending | decimalPlaces
                      }}
                    </span>
                  </td>

                  <!-- <td>
										<a href="javascript:;" (click)="gotoPurchaseOrders(vs)"
											title="View SKU purchase orders">
											{{ vs.qty_incoming | decimalPlaces }}
										</a>
									</td>
									<td>
										{{ vs.qty_onhand | decimalPlaces }}
									</td>
									<td>
										{{ vs.qty_pending | decimalPlaces }}
									</td>
									<td>
										<span
											[ngClass]="{'text-danger font-500':  r.qty_limit_notify > 0 && vs.qty_available <= vs.qty_limit_notify}">
											{{ vs.qty_available | decimalPlaces }}
										</span>
									</td> -->

                  <td
                    *ngIf="
                      authService.loginUser.role >= 2 &&
                      columnActive('sourcingAssignees')
                    "
                  >
                    <div class="sourcing"></div>
                  </td>
                  <td class="text-right" *ngIf="columnActive('wholesalePrice')">
                    {{ vs.wholesale_price | currency }}
                  </td>

                  <ng-container *ngxPermissionsOnly="'skuUnitCost.read'">
                    <td class="text-right" *ngIf="columnActive('unitCost')">
                      <div *ngIf="vs.unit_costs">
                        <span
                          class="weighted"
                          popoverTitle="Unit Costs"
                          placement="top"
                          triggers="mouseenter:mouseleave"
                        >
                          <span class="value">{{
                            (vs.base_price ? vs.base_price.weighted : 0) | currency
                          }}</span>
                        </span>
                      </div>
                    </td>
                  </ng-container>
                  <td *ngIf="columnActive('category')">
                    {{ vs.product_category?.product_category }}
                  </td>
                  <td *ngIf="columnActive('subCategory')">
                    {{ vs.product_sub_category?.sub_category }}
                  </td>
                  <td *ngIf="columnActive('tags')">
                    <span
                      *ngFor="let tag of vs.tags; let idx = index"
                      [ngClass]="{
                        'kt-badge kt-badge--secondary kt-badge-sm kt-badge--outline kt-badge--pill':
                          vs.tags.length !== 0,
                      }"
                      >{{ tag?.tag_details?.name }}</span
                    >
                  </td>
                  <td *ngIf="columnActive('customFields')">
                    <lum-custom-field-value-details
                      [customFieldValues]="vs?.custom_field_values || []"
                    ></lum-custom-field-value-details>
                  </td>

                  <td *ngIf="columnActive('uom')">
                    <span *ngIf="vs?.type !== eItemType.KIT">
                      {{ vs?.unit_class?.name }}
                    </span>
                  </td>

                  <td class="actions text-right">
                    <div
                      ngbDropdown
                      *ngIf="!checked[vs.id]"
                      class="d-inline-block"
                      container="body"
                    >
                      <button
                        ngbDropdownToggle
                        mat-mini-fab
                        type="button"
                        color="default"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="flaticon-more-1"></i>
                      </button>

                      <div ngbDropdownMenu aria-labelledby="action-button">
                        <button
                          ngbDropdownItem
                          (click)="editRfq(vs)"
                          *ngIf="authService.loginUser.prwx == 7"
                        >
                          <i class="fas fa-edit"></i>
                          Edit SKU
                        </button>
                        <button
                          type="button"
                          ngbDropdownItem
                          *ngIf="checkIfCanCreateAdjustmentEntry(vs)"
                          (click)="createAdjustmentEntry(vs)"
                        >
                          <i class="fas fa-edit"></i>
                          Create Adjustment Entry
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="assignRFQ(vs)"
                          *ngIf="
                            authService.loginUser.role >= 88 &&
                            authService.loginUser.prwx == 7
                          "
                        >
                          <i class="fas fa-user-friends"></i>
                          Assign SKU Admin
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="assignRFQ(vs)"
                          *ngIf="
                            authService.loginUser.role == 8 &&
                            authService.loginUser.prwx == 7
                          "
                        >
                          <i class="fas fa-user-friends"></i>
                          Assign SKU Member
                        </button>

                        <button
                          ngbDropdownItem
                          (click)="addClient(vs)"
                          *ngIf="authService.loginUser.prwx == 7"
                        >
                          <i class="fas fa-user-friends"></i>
                          Assign SKU Client
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="addQuotation(vs)"
                          *ngIf="
                            authService.loginUser.role != 2 &&
                            authService.loginUser.prwx == 7
                          "
                        >
                          <i class="fas fa-plus"></i>
                          Add Quotation
                        </button>
                        <a
                          ngbDropdownItem
                          [href]="'/inventory/' + vs.id + '/view'"
                          (click)="showDetails($event, vs, 'quotations')"
                        >
                          <i class="fas fa-file-alt"></i>
                          View Quotations
                        </a>
                        <!-- <button
                          ngbDropdownItem
                          (click)="transferRfq(vs)"
                          class="text-info"
                        >
                          <i class="fas fa-map-pin text-info"></i>
                          Transfer SKU
                        </button> -->
                        <button
                          ngbDropdownItem
                          (click)="exportRfqToPDF(vs)"
                          class="text-info"
                        >
                          <i class="fas fa-file-pdf text-info"></i>
                          Export to PDF
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="promoteVariantToMasterSku(vs)"
                          *ngIf="vs.variant_parent_id !== 0"
                        >
                          <i class="fas fa-level-up-alt"></i>
                          Promote Variant SKU to Master SKU
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="discontinue(vs)"
                          *ngIf="
                            !vs.is_discontinued &&
                            authService.loginUser.is_admin &&
                            authService.loginUser.prwx == 7
                          "
                          class="text-warning"
                        >
                          <i class="fas fa-stop text-warning"></i>
                          Discontinue SKU
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="continue(vs)"
                          *ngIf="
                            vs.is_discontinued &&
                            authService.loginUser.is_admin &&
                            authService.loginUser.prwx == 7
                          "
                          class="text-info"
                        >
                          <i class="fas fa-play text-info"></i>
                          Reactivate SKU
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="delete(vs)"
                          class="text-danger"
                          *ngxPermissionsOnly="['skus.delete']"
                        >
                          <i class="fas fa-trash text-danger"></i>
                          Delete SKU
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>

        <div
          class="is-loading"
          *ngIf="rfqService.gettingRecords || isLoadingRecords"
        >
          <div class="is-loading__spinner">
            <mat-spinner [diameter]="32"></mat-spinner>
          </div>
        </div>
      </div>

      <mat-paginator
        [length]="rfqRecord.total"
        [pageSize]="params.per_page"
        [pageIndex]="params.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginationChange($event)"
        class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
      >
      </mat-paginator>
    </div>
  </div>
</article>
